import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Ubicaciones from '@/views/Ubicaciones.vue'
import Categorias from '@/views/Categorias.vue'
import Marcas from '@/views/Marcas.vue'
import SephoraSale from '@/views/SephoraSale.vue'
import Skincare from '../views/Skincare.vue'
import Mkp from '../views/Mkp.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Ubicaciones',
    name: 'Ubicaciones',
    component: () => import(/* webpackChunkName: "Puntos de venta" */ '../views/Ubicaciones.vue')
  },
  {
    path: '/Categorias',
    name: 'Categorias',
    component: () => import(/* webpackChunkName: "Categorias" */ '../views/Categorias.vue')
  },
  /*{
    path: '/Marcas',
    name: 'Marcas',
    component: () => import( '../views/Marcas.vue')
  }, */
  {
  path: '/Marcas/:marca?', // 
  name: 'Marcas',
  component: () => import('../views/Marcas.vue') 
  },
  {
  path: '/SephoraSale/:marca?', // 
  name: 'SephoraSale',
  component: () => import('../views/SephoraSale.vue') 
  },
  {
    path: '/Lifestyle',
    name: 'Lifestyle',
    component: () => import(/* webpackChunkName: "Lifestyle" */ '../views/Lifestyle.vue')
  },
  {
    path: '/Maquillaje',
    name: 'Maquillaje',
    component: () => import(/* webpackChunkName: "Maquillaje" */ '../views/Maquillaje.vue')
  },
    {
    path: '/Snacks',
    name: 'Snacks',
    component: () => import(/* webpackChunkName: "Snacks" */ '../views/Snacks.vue')
  },
  {
    path: '/Perfumes',
    name: 'Perfumes',
    component: () => import(/* webpackChunkName: "Perfumes" */ '../views/Perfumes.vue')
  },
  {
    path: '/Skincare',
    name: 'Skincare',
    component: () => import(/* webpackChunkName: "Skincare" */ '../views/Skincare.vue')
  },
  {
    path: '/Sets',
    name: 'Sets',
    component: () => import(/* webpackChunkName: "Sets" */ '../views/Sets.vue')
  },
  {
    path: '/Mkp',
    name: 'Mkp',
    component: () => import(/* webpackChunkName: "Mkp" */ '../views/Mkp.vue')
  },


  // {
  //   path: '/Login',
  //   name: 'Login',
  //   component: () => import(/* webpackChunkName: "Login" */ '../views/backoffice/Login.vue')
  // },

]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // scrollBehavior: () => {
  //   window.scrollTo(0, 0);
  // }
})

export default router
